import { F_MapMarkerLabelFragment } from '__generated__v2/graphql';
import { isDefined } from 'libs/utils/typesafe/isDefined';
import { useCtxMapView } from 'pages/special/OsloDesignFair/map/CtxMapView';
import {
    GlobalLayerIds,
    GlobalSourceIds
} from 'pages/special/OsloDesignFair/map/mapContent/Markers/constants';
import { EmptyLayer } from 'pages/special/OsloDesignFair/map/markers/view/EmptyLayer';
import { useLoadMapImages } from 'pages/special/OsloDesignFair/map/markers/view/useLoadMapImages';
import { Layer, Source } from 'react-map-gl';
interface Props {
    markers: F_MapMarkerLabelFragment[];
}

export function getFeature_LabelSymbol(marker: F_MapMarkerLabelFragment): GeoJSON.Feature {
    return {
        type: 'Feature',
        properties: {
            markerId: marker.id,
            text: marker.text,
            imageUrl: marker.imageUrl,
            smallImageUrl: marker.smallImageUrl
        },
        geometry: {
            type: 'Point',
            coordinates: [marker.lng, marker.lat]
        }
    };
}

export const LabelMarkers = (props: Props) => {
    const ctxMapView = useCtxMapView();
    const { isLoaded } = useLoadMapImages({
        mapRef: ctxMapView.mapRef,
        imageUrls: props.markers.flatMap((e) => [e.imageUrl, e.smallImageUrl]).filter(isDefined)
    });

    if (!isLoaded) {
        return null;
    }

    const features = props.markers.filter((e) => !e.isHidden).map(getFeature_LabelSymbol);

    return (
        <Source
            id={GlobalSourceIds.Labels}
            type="geojson"
            data={{
                type: 'FeatureCollection',
                features
            }}
        >
            <Layer
                id={GlobalLayerIds.Labels}
                source={GlobalSourceIds.Labels}
                type="symbol"
                paint={{
                    'text-color': '#000',
                    'text-halo-color': '#fff',
                    'text-halo-width': 1,
                    'icon-opacity': 1
                }}
                layout={{
                    'text-font': ['Inter Medium'],
                    'text-offset': [1.2, 0],
                    'text-anchor': 'left',
                    'text-size': 13,
                    'text-padding': 20,
                    'text-field': ['step', ['zoom'], '', 18, ['get', 'text']],
                    'icon-size': ['step', ['zoom'], 0.17, 18, 0.25],
                    'icon-image': ['step', ['zoom'], ['get', 'imageUrl'], 18, ['get', 'imageUrl']],
                    'icon-optional': false,
                    'icon-allow-overlap': true,
                    'text-optional': true,
                    'text-allow-overlap': false,

                    visibility: 'visible'
                }}
            />
            <EmptyLayer id={GlobalSourceIds.Labels + '|last'} />
        </Source>
    );
};
